import { useEffect, useState } from "react";

const TICK_MS = 30_000;

const formatTimeAgo = (ms: number): string => {
	const minutes = Math.floor(ms / 60_000);
	if (minutes < 1) return "just now";
	if (minutes < 60) return `${minutes} ${minutes === 1 ? "min" : "mins"} ago`;

	const hours = Math.floor(minutes / 60);
	if (hours < 24) return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;

	const days = Math.floor(hours / 24);
	return `${days} ${days === 1 ? "day" : "days"} ago`;
};

export function useTimeAgo(date: string): string {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		const interval = setInterval(() => setNow(Date.now()), TICK_MS);
		return () => clearInterval(interval);
	}, []);

	return formatTimeAgo(Math.max(0, now - new Date(date).getTime()));
}
